let supported = true;

try {
    eval('const o={},x={...o};new Map()'); // eslint-disable-line no-eval
} catch (e) {
    supported = false;
}

/**
 * Check if this browser supports (can parse) ES6 features.
 * @returns {Boolean}
 */
const supportsES6 = () => supported;

export default supportsES6;
